module.exports = __webpack_public_path__ + "static/flatart-insta-ss2-0900dec46d55533af27fd3f163b495c6.png";